var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { SortOrder } from 'api';
export function sortArray(array, order) {
    var comparator = function (a, b) {
        if (order === SortOrder.Asc) {
            return a < b ? -1 : a > b ? 1 : 0;
        }
        else if (order === SortOrder.Desc) {
            return a > b ? -1 : a < b ? 1 : 0;
        }
        else {
            return 0; // if '' -> no sorting
        }
    };
    return __spreadArray([], array, true).sort(comparator);
}
export function sortArrayOfObjects(key, array, order) {
    var comparator = function (a, b) {
        if (order === SortOrder.Asc) {
            return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
        }
        else if (order === SortOrder.Desc) {
            return a[key] > b[key] ? -1 : a[key] < b[key] ? 1 : 0;
        }
        else {
            return 0; // if '' -> no sorting
        }
    };
    return __spreadArray([], array, true).sort(comparator);
}
